import { BaseService, Service } from "/@/cool";
@Service("modelExpressOrder")
class ModelExpressOrder extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["info"] = prefix + "info";
		this.permission["page"] = prefix + "page";
		this.permission["manualSign"] = prefix + "manualSign";
		this.permission["packDetail"] = prefix + "packDetail";
	}

	/** 打包/续流程详情（与后端 model_express_order packDetail 对应） */
	packDetail(data: { id: number }) {
		return this.request({
			url: "/packDetail",
			method: "POST",
			data
		});
	}

	manualSign(data: any) {
		return this.request({
			url: "/manualSign",
			method: "POST",
			data
		});
	}
}
export default ModelExpressOrder;
